// © Microsoft Corporation. All rights reserved.

import { TelemetryLibraryBase } from "../telemetry-interfaces";

/**
 * Static global variables used to reference to Telemetry library implementation.
 * @var TelemetryLibraryBase
 */
export let Telemetry: TelemetryLibraryBase = null;

/**
 * Initialize Telemetry
 * @param telemetry TelemetryLibraryBase implementation
 */
export function initTelemetry(telemetry: TelemetryLibraryBase): void {
    Telemetry = telemetry;
}
